// GitHub OAuth Configuration
// Update these values after registering your OAuth app on GitHub

import { getGitHubCallbackUrl } from './environment';

export const GITHUB_CONFIG = {
  // Client ID from GitHub OAuth app (you'll get this after registration)
  CLIENT_ID: '0v23li2dPQRWIp2UPuQk',
  
  // Client Secret from GitHub OAuth app
  CLIENT_SECRET: '07db994c5c5323cd45d0452c89cf221e7bc996da',
  
  // Redirect URI - automatically detects environment
  REDIRECT_URI: getGitHubCallbackUrl(),
  
  // Allowed GitHub usernames for admin access
  ALLOWED_USERS: ['Undead6969', 'saanjay'],
  
  // OAuth scopes (permissions we request)
  SCOPES: ['read:user', 'user:email'],
  
  // GitHub API endpoints
  GITHUB_AUTH_URL: 'https://github.com/login/oauth/authorize',
  GITHUB_TOKEN_URL: 'https://github.com/login/oauth/access_token',
  GITHUB_USER_API: 'https://api.github.com/user',
};

// Helper function to build GitHub OAuth URL
export const buildGitHubAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: GITHUB_CONFIG.CLIENT_ID,
    redirect_uri: GITHUB_CONFIG.REDIRECT_URI,
    scope: GITHUB_CONFIG.SCOPES.join(' '),
    state: Math.random().toString(36).substring(7), // Random state for security
  });
  
  return `${GITHUB_CONFIG.GITHUB_AUTH_URL}?${params.toString()}`;
};

// Helper function to check if a GitHub username is allowed
export const isAllowedGitHubUser = (username) => {
  return GITHUB_CONFIG.ALLOWED_USERS.includes(username);
};

// Environment detection helper
export const getEnvironment = () => {
  if (typeof window === 'undefined') return 'server';
  return window.location.hostname === 'localhost' ? 'development' : 'production';
};

// Get the appropriate redirect URI for current environment
export const getCurrentRedirectUri = () => {
  return GITHUB_CONFIG.REDIRECT_URI;
};
